import {DefaultService} from "./DefaultService";

class RestaurantCategoryService extends DefaultService {
    getRestaurantCategories(params){
        return this.post('/customer/restaurant-categories', params).then(res => res.data)
    }
}

export default RestaurantCategoryService;